import { formatPrice } from "@/lib/store";
import { useRates } from "@/lib/pricing";
import { payLine } from "@/lib/proposal";
import { chip } from "@/components/site/OrderSpecFields";

const COUNTS = Array.from({ length: 21 }, (_, i) => i + 1);

// Quais formas de pagamento entram na mensagem (taxas da maquininha do painel).
export const ProposalPayment = ({ amount, cash, installments, onChange }) => {
  useRates();
  if (!(amount > 0)) return null;
  const toggle = (n) => onChange({ installments: installments.includes(n) ? installments.filter((x) => x !== n) : [...installments, n].sort((a, b) => a - b) });
  return (
    <div data-testid="proposal-payment">
      <p className="text-sm font-semibold text-white">Formas de pagamento na mensagem</p>
      <p className="mt-1 text-xs text-zinc-400">Toque para mostrar ou esconder cada opção.</p>
      <div className="mt-3 flex flex-wrap gap-1.5">
        <button type="button" data-testid="proposal-pay-cash" onClick={() => onChange({ cash: !cash })} className={chip(cash)}>À vista</button>
        {COUNTS.map((n) => <button type="button" key={n} data-testid={`proposal-pay-${n}x`} onClick={() => toggle(n)} className={`${chip(installments.includes(n))} !px-3`}>{n}x</button>)}
      </div>
      {(cash || installments.length > 0) && (
        <ul data-testid="proposal-pay-preview" className="mt-3 space-y-1 text-sm text-zinc-200">
          {cash && <li>À vista no Pix ou dinheiro: <strong className="text-white">{formatPrice(amount)}</strong></li>}
          {installments.map((n) => <li key={n}>{payLine(amount, n)}</li>)}
        </ul>
      )}
    </div>
  );
};
